import React, { useEffect, useState } from 'react';
import SpotlightHeader from '../../Common/Header';
import BottomBar from '../../../components/BottomBar';
import './PayDay.scss';
import { DateTime } from 'luxon';
import { getOrdinalSuffixedNumber } from '../../helpers/boh_spotlights';
const formatPayDay = dob => {
  if (!dob) return '';
  const date = DateTime.fromFormat(dob, 'yyyyMMdd');
  const ordinal_suffixed_number = getOrdinalSuffixedNumber(date.day);
  return `${date.toFormat('MMMM')} ${ordinal_suffixed_number}`;
};
const getPayDay = (payDays, storage_key) => {
  const nextIndex = (+localStorage.getItem(storage_key) + 1) % payDays.length;
  localStorage.setItem(storage_key, nextIndex);
  return payDays[nextIndex];
};
function usePayday(storage_key, data) {
  const [currentPayDay, setCurrentPayday] = useState(null);
  useEffect(() => {
    if (!!(data !== null && data !== void 0 && data.pay_days) && !currentPayDay) {
      setCurrentPayday(getPayDay(data.pay_days, storage_key));
    }
  }, [data, currentPayDay, storage_key]);
  return currentPayDay;
}
const PayDay = props => {
  const {
    metadata,
    bohStyle,
    text,
    data
  } = props;
  const storage_key = 'pay_day_index';
  const hide_poweredbyupshow = metadata.hide_poweredbyupshow;
  const currentPayday = usePayday(storage_key, data);
  const customText = {
    ...text,
    title: 'Payday Reminder'
  };
  const {
    accent_color,
    text_accent_color,
    containerStyle
  } = bohStyle;
  return /*#__PURE__*/React.createElement("div", {
    className: "paydate-container",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(SpotlightHeader, {
    text: customText,
    metadata: metadata
  }), /*#__PURE__*/React.createElement("div", {
    className: "paydate-info-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "paydate-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "paydate-info-title"
  }, /*#__PURE__*/React.createElement("div", null, currentPayday ? formatPayDay(currentPayday.pay_day_dob) : 'Month DD')))), /*#__PURE__*/React.createElement(BottomBar, {
    accent_color: accent_color,
    accent_text_color: text_accent_color,
    hide_poweredbyupshow: hide_poweredbyupshow
  }));
};
export default PayDay;